import { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { appConnect } from '~/store/hooks'
import { graphql } from '@apollo/client/react/hoc'
import get from 'lodash-es/get'
import { withProps } from 'recompact'

import { isTouchUI } from 'store/userInterface/selectors'

import { showPanel } from 'store/panel'
import { start2DFit } from 'store/camera'

import routes from 'config/routes'
import { currentUserIsCustomer } from 'lib/currentUserIs'
import { GET_QUOTE_PANEL } from 'store/panel/types'
import { GET_SALESFORCE_USER_ID_QUERY } from 'client/queries'
import withUser from 'client/decorators/withUser'

import Button from 'components/UIKit/Button'
import { ClickablePopoverItem } from 'components/UIKit/Popover'
import { ToolbarGroup, ToolbarItem, ClickableToolbarItem } from 'components/UIKit/Toolbar'

import { hasPermission } from 'components/RequiredPermission'
import UserDropdown from 'components/UserDropdown'
import { withLocation, withNavigate } from '~/utils/reactRouterHOC'
import { resolvePath } from 'react-router-dom'

class TopRight extends Component {
  constructor(props) {
    super(props)
    this.touch = {
      active: props.isTouchUI,
      variant: props.isTouchUI ? 'dark' : 'light',
      separator: props.isTouchUI ? null : 'left',
      size: props.isTouchUI ? 'square' : null,
    }
  }

  renderCalculationsDropdown() {
    const { salesforceData, onGetQuote, navigate, hideGetQuote } = this.props
    const items = []

    if (!hideGetQuote && !salesforceData.loading) {
      if (get(salesforceData, 'Salesforce.salesforceUserId')) {
        items.push({
          title: 'Generate Quote',
          onClick: onGetQuote,
        })
      } else {
        items.push({
          title: 'Generate Quote',
          to: routes.salesforceAuthentication,
        })
      }
    }

    items.push({
      title: 'Calculate Productivity',
      onClick: () => navigate(resolvePath(routes.modals.savings.replace('/', ''), this.props.location.pathname)),
    })

    return (
      <ClickablePopoverItem
        items={items}
        renderTrigger={({ isDropdownVisible }) => (
          <ToolbarItem space="s" separator={this.touch.separator} paddingLeft="s">
            <Button
              dropdown={!this.touch.active}
              icon="calculator"
              isDropdownVisible={isDropdownVisible}
              label={this.touch.active ? null : 'Tools'}
              noBorder={!this.touch.active}
              responsive
              size={this.touch.size}
              variant={this.touch.variant}
            />
          </ToolbarItem>
        )}
        right
        variant={this.touch.variant}
        border={this.isTouch}
      />
    )
  }

  renderExportButton() {
    return (
      <ClickableToolbarItem
        paddingLeft="s"
        paddingRight="s"
        separator={this.touch.separator}
        variant={this.touch.variant}
      >
        <Button
          icon="export"
          label={this.touch.active ? null : 'Export'}
          noBorder={!this.touch.active}
          responsive
          size={this.touch.size}
          onClick={() =>
            this.props.navigate(
              resolvePath(routes.modals.exportPDFLayout.replace('/', ''), this.props.location.pathname)
            )
          }
          variant={this.touch.variant}
        />
      </ClickableToolbarItem>
    )
  }

  render() {
    const { navigate } = this.props

    return (
      <ToolbarGroup size={this.touch.active ? '30%' : '40%'} alignment="right">
        <ClickableToolbarItem paddingLeft="s" paddingRight="s" separator={this.touch.separator}>
          <Button
            label="Review Installer Details"
            icon="clipboard"
            noBorder
            responsive
            onClick={() =>
              navigate(resolvePath(routes.modals.installReview.replace('/', ''), this.props.location.pathname))
            }
          />
        </ClickableToolbarItem>
        {!currentUserIsCustomer(this.props.user) && this.renderCalculationsDropdown()}
        {!currentUserIsCustomer(this.props.user) && this.renderExportButton()}
        <UserDropdown isTouchUI={this.touch.active} />
      </ToolbarGroup>
    )
  }
}

TopRight.propTypes = {
  flags: PropTypes.object,
  hideGetQuote: PropTypes.bool,
  isTouchUI: PropTypes.bool,
  navigate: PropTypes.func,
  location: PropTypes.object,
  onGetQuote: PropTypes.func,
  onUnimplementedFeatureClick: PropTypes.func,
  salesforceData: PropTypes.object,
  user: PropTypes.object,
}

const mapDispatchToProps = dispatch => ({
  onGetQuote() {
    dispatch(start2DFit())
    dispatch(showPanel({ type: GET_QUOTE_PANEL }))
  },
})

const mapStateToProps = store => ({
  isTouchUI: isTouchUI(store),
})

export default compose(
  withNavigate,
  withLocation,
  withUser,
  hasPermission({
    name: 'Get Quote',
    withPermissions: true,
  }),
  withProps(props => ({
    hideGetQuote: props.hideGetQuote || !props.permissions.isAllowed,
    loading: props.loading || props.permissions.isLoading,
  })),
  graphql(GET_SALESFORCE_USER_ID_QUERY, {
    name: 'salesforceData',
  }),
  appConnect(mapStateToProps, mapDispatchToProps)
)(TopRight)
